/* Model */
class HoursOfServiceTypeModel extends App.Models.BaseModel {
    modelUrl = 'HoursOfServiceType';
}

App.Models.HoursOfServiceType = HoursOfServiceTypeModel;

/* Collection */
class HoursOfServiceTypeCollection extends App.Collections.BaseCollection {
    url = 'HoursOfServiceType';
    model = App.Models.HoursOfServiceType;
}

App.Collections.HoursOfServiceTypes = HoursOfServiceTypeCollection;

/* Router */
class HoursOfServiceTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'HoursOfServiceType';
        const model = App.Models.HoursOfServiceType;
        const collectionClass = App.Collections.HoursOfServiceTypes;

        super(entityName, model, collectionClass);
    }

    invalidateField = (invalidated, message) => {
        invalidated.rootEl.className = invalidated.rootEl.className + 'control-group error';
        this.allow_submit.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(message)
        );
        this.allow_submit.status = false;
    }

    buildMessage = (key1, key2) => {
        return Monet.I18n.getResourcesByKey(key1) + " " +
            Monet.I18n.getResourcesByKey("error.isrequiredwhen") + " " +
            Monet.I18n.getResourcesByKey(key2) + " " +
            Monet.I18n.getResourcesByKey("error.isfilled");
    }

    validateDependency = (durationMinutes, thresholdMinutes) => {

        var durationMinutesValue = durationMinutes.getValue();
        var thresholdMinutesValue = thresholdMinutes.getValue();

        if ((durationMinutesValue !== "" && durationMinutesValue > 0) &&
            (thresholdMinutesValue === "" || thresholdMinutesValue === 0)) {
            this.invalidateField(thresholdMinutes, this.buildMessage(thresholdMinutes.field.label, durationMinutes.field.label));
        }

        if ((durationMinutesValue === "" || durationMinutesValue === 0) &&
            thresholdMinutesValue !== "" && thresholdMinutesValue > 0) {
            this.invalidateField(durationMinutes, this.buildMessage(durationMinutes.field.label, thresholdMinutes.field.label));
        }
    }

    clearErrorClass = (field) => {
        field.rootEl.className = field.rootEl.className.replace('control-group error', '');
    }

    onValidate = () => {
        var fields = App.Forms.HoursOfServiceType.form.fields;
        var breakTimeDurationMinutes = fields.breakTimeDurationMinutes;
        var breakTimeThresholdMinutes = fields.breakTimeThresholdMinutes;
        var lunchTimeDurationMinutes = fields.lunchTimeDurationMinutes;
        var lunchTimeThresholdMinutes = fields.lunchTimeThresholdMinutes;
        var forceBreakTime = fields.forceBreakTime;
        var forceLunchTime = fields.forceLunchTime;

        [breakTimeDurationMinutes, breakTimeThresholdMinutes, lunchTimeDurationMinutes, lunchTimeThresholdMinutes].forEach(this.clearErrorClass);

        this.validateDependency(breakTimeDurationMinutes, breakTimeThresholdMinutes);
        this.validateDependency(lunchTimeDurationMinutes, lunchTimeThresholdMinutes);

        this.validateDependency(breakTimeDurationMinutes, forceBreakTime);
        this.validateDependency(lunchTimeDurationMinutes, forceLunchTime);
    }
}

App.Routers.HoursOfServiceType = HoursOfServiceTypeRouter;
